import { init, isTMA, miniApp, retrieveRawInitData, viewport } from '@tma.js/sdk-react';

/**
 * Подключение к Telegram. Возвращает сырой initData для входа на сервере;
 * null — приложение открыто не в Telegram (обычный браузер), войти нельзя.
 */
export async function initTelegram(): Promise<string | null> {
  if (!isTMA()) return null;
  try {
    init();
    if (miniApp.mount.isAvailable()) miniApp.mount();
    if (miniApp.ready.isAvailable()) miniApp.ready();
    if (viewport.mount.isAvailable()) {
      await viewport.mount();
      if (viewport.expand.isAvailable()) viewport.expand();
    }
  } catch (err) {
    // Оформление окна — не критично, войти всё равно можно
    console.warn('Telegram SDK: окно не настроено', err);
  }
  return retrieveRawInitData() ?? null;
}
